import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LoadRecommendedProducts,
} from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import { chain as chain2, SortProducts } from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";

addToChainAfter(chain, LoadRecommendedProducts, (props: any) => {
    if (props.parameter.carouselType === "featuredProducts" && props.parameter.featuredProducts?.length) {
        props.getProductCollectionParameter = { productIds: props.parameter.featuredProducts.map((p: any) => p.fields?.product?.id), resetSort: true };
    }

    props.getProductCollectionParameter = {
        ...props.getProductCollectionParameter,
        expand: ["properties"],
    };
});

addToChainAfter(chain2, SortProducts, (props: any) => {
    const sortedProducts = [] as any[];

    if (props.parameter.getProductCollectionParameter?.resetSort) {
        props.parameter.getProductCollectionParameter?.productIds.forEach((id: string) => {
            const product = props.products.find((p: any) => p.id === id);
            if (product) {
                sortedProducts.push(product);
            }
        });
        props.products = sortedProducts;
    }
});
